import {LoginFlowState} from '../models/login-flow.models';
import {computed, inject, Injectable, signal} from '@angular/core';
import {AuthApiService} from '../api/auth-api.service';
import {firstValueFrom} from 'rxjs';
import {LoginCredential} from '../models/auth.models';
import {ToastMessageEffectService} from '../../services/toast-message-effect.service';

@Injectable({ providedIn: 'root' })
export class LoginFlowStore {
	private api = inject(AuthApiService);
	private toastEffect = inject(ToastMessageEffectService)

	private state = signal<LoginFlowState>({
		loading: false,
		tokens: null,
		error: null
	});

	readonly tokens = computed(() => this.state().tokens);
	readonly loading = computed(() => this.state().loading);
	readonly error = computed(() => this.state().error);

	constructor() {
		this.toastEffect.registerErrorSignal(this.error)
	}

	async startLogin(credentials: LoginCredential) {

		this.patch({ loading: true, error: null });

		try {
			const tokens = await firstValueFrom(this.api.login(credentials));

			this.patch({
				tokens,
				loading: false
			});

		} catch ( err: any ) {
			this.patch({
				loading: false,
				error: err.error.message
			});
		}
	}

	reset() {
		this.state.set({ loading: false, tokens: null, error: null });
	}

	private patch(p: Partial<LoginFlowState>) {
		this.state.update(s => ({ ...s, ...p }));
	}
}
